import { SessionStorage } from '../../../../../../../projects/webdpt/framework/storage/session-storage';

/**
 * 獲取儲存的格式
 * @export
  */
export class DwRouteInfoStorage extends SessionStorage {
}

